import React, { useContext, useEffect } from 'react'
import { Title } from '@provi/provi-components'
import { TemplateDeclarationContext } from '../../../components/template-declaration/context'
import { TemplateDeclaration } from '../../../components/template-declaration'
import { FormFormik } from './form'
import { Container } from './styles'

export const GeneralComments = () => {
  const { goToNextScreen, incomeStatementPath, setDataModal } = useContext(TemplateDeclarationContext)

  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
  return (
    <TemplateDeclaration subTitle="Pesquisa de acompanhamento">
      <Container>
        <Title text="Tem alguma dúvida ou sugestão pra gente? Você pode escrever aqui :)" />
        <div
          style={{
            marginTop: '108px'
          }}
        >
          <FormFormik data={incomeStatementPath && incomeStatementPath.ReadGeneralComments} goToNextScreen={goToNextScreen} />
        </div>
      </Container>
    </TemplateDeclaration>
  )
}
